// The account's `type` is the single source of truth for a business's category.
// Reservations mode (vs appointments) is enabled for Bars and Restaurants.
// Compared case-insensitively so callers don't depend on the stored casing.
export const isReservationsBusinessType = type => ["restaurant", "bar"].includes((type || "").toLowerCase());

export const getBookingTypeDisplayName = type => (isReservationsBusinessType(type) ? "Reservations" : "Bookings");

// Mirrors functions/src/utils/businessType.ts — keep the two in sync by hand. That
// copy is the tested one; see its comment for why these are only a starting guess, and
// why `restaurant`/`bar` are deliberately absent. Drift is not silent: the
// `preset table mirror` test in functions/src/utils/test/businessType.spec.ts reads this
// file and fails if the two arrays stop matching.
const RESOURCE_LABEL_PRESETS = [
  { match: ["night club", "club"], label: { singular: "Table", plural: "Tables" } },
  { match: ["barber"], label: { singular: "Barber", plural: "Barbers" } },
  { match: ["salon", "hair", "stylist"], label: { singular: "Stylist", plural: "Stylists" } },
  { match: ["spa", "massage", "therap"], label: { singular: "Therapist", plural: "Therapists" } },
  {
    match: ["dental", "dentist", "medical", "doctor", "clinic", "chiropract", "health", "vet"],
    label: { singular: "Provider", plural: "Providers" }
  },
  { match: ["bowling"], label: { singular: "Lane", plural: "Lanes" } },
  { match: ["gym", "fitness", "yoga", "pilates", "train"], label: { singular: "Trainer", plural: "Trainers" } },
  { match: ["tattoo", "piercing", "jewel", "nail"], label: { singular: "Artist", plural: "Artists" } },
  { match: ["retail", "shop", "store"], label: { singular: "Product", plural: "Products" } },
  { match: ["worship", "church", "temple", "mosque", "synagogue"], label: { singular: "Option", plural: "Options" } },
  { match: ["auto", "mechanic", "tire", "repair"], label: { singular: "Bay", plural: "Bays" } },
  { match: ["photo", "studio"], label: { singular: "Studio", plural: "Studios" } }
];

export const getResourceLabel = accountType => {
  const type = (accountType || "").toLowerCase().trim();
  if (!type) {
    return null;
  }
  const preset = RESOURCE_LABEL_PRESETS.find(entry => entry.match.some(term => type.includes(term)));
  // A miss returns null, never a generic "Option" — see the functions copy.
  return preset ? { ...preset.label } : null;
};
